import { useContext } from "react";
import { ModalSettingContext } from "../../index";
import Select from "@UI/New/Select";
import { compareOptionsByLabel } from "@/helpers/new/compareOptionsByLabel";
import s from './index.module.css';
import { filterOptionsByLabel } from "@/helpers/new/filterOptionsByLabel";

export const SeminarianSelection = () => {
    const { state, setFieldInState, courseSeminariansList, loadingCourseSeminarians } = useContext(ModalSettingContext);

    const fieldsSeminarian = {
        loading: loadingCourseSeminarians,
        showSearch: true,
        allowClear: true,
        filterSort: compareOptionsByLabel,
        filterOption: filterOptionsByLabel,
        onChange: e => setFieldInState({field: 'speaker_id', value: e, resetFields: ['childrens'] }),
        options: courseSeminariansList,
        value: state.speaker_id,
        placeholder: 'Выберите спикера',
        notFoundContent: !state.direction
            ? "Сначала выберите курс" 
            : "Спикеры не найдены" 
    };

    return (
        <Select 
            wrapperClassName={s.wrapperSelect} 
            className={s.select} 
            fields={fieldsSeminarian} 
        />
    );
};